import { FormConverter } from '../../../utilities/form-mapper/form-converter';
import { UserDetails } from '../user.model';
import { UserModelForm } from './user-model.form';

export class UserModelMapper extends FormConverter<
  Partial<UserDetails>,
  UserModelForm
> {
  public toFormModel(data: UserDetails): UserModelForm {
    const form = new UserModelForm();

    form.badgeNumber = data.badgeNumber ?? null;
    form.firstName = data.firstName ?? null;
    form.lastName = data.lastName ?? null;
    form.email = data.email ?? null;
    form.level = data.level ?? null;
    form.role = data.role ?? null;
    form.title = data.title ?? null;
    form.enabled = data.enabled ?? null;

    return form;
  }

  public toObject(form: UserModelForm): UserDetails {
    return {
      badgeNumber: form.badgeNumber,
      firstName: form.firstName,
      lastName: form.lastName,
      email: form.email,
      level: form.level,
      role: form.role,
      title: form.title,
      enabled: form.enabled,
    };
  }

  private setDateWithTime(time: Date, date: Date): Date {
    date.setHours(time.getHours());
    date.setMinutes(time.getMinutes());
    date.setSeconds(0);
    return date;
  }
}
